import { Alert, Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';
import FormikWorkingDay from './FormikWorkingDay';

interface FormikTeamWorkingHoursProps {
    namePrefix?: string; // Default: "WorkingHours"
    readOnly?: boolean;
}

const FormikTeamWorkingHours: React.FC<FormikTeamWorkingHoursProps> = ({ namePrefix = 'WorkingHours', readOnly = false }) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Alert severity="info">All times are local to the team's meeting address</Alert>
                </Grid>
                {days.map((day) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={day}>
                        <FormikWorkingDay dayName={day} namePrefix={`${namePrefix}.${day}`} readOnly={readOnly} />
                    </Grid>
                ))}
            </Grid>
        </LocalizationProvider>
    );
};

export default FormikTeamWorkingHours;
